import Reveal, { SectionHeading } from "../components/Reveal";
import { WHY_US } from "../data";

export default function WhyUs() {
  return (
    <section id="why-us" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading eyebrow="Why Work With Us" title={<>Built for long-term partnerships</>} />
        <div className="mt-14 grid gap-px overflow-hidden rounded-2xl border border-stone-200 bg-stone-200 shadow-[0_20px_60px_rgba(20,23,28,0.05)] sm:grid-cols-2 lg:grid-cols-3" data-testid="why-us-grid">
          {WHY_US.map((w, i) => (
            <Reveal key={w.title} delay={0.05 * i} className="h-full">
              <div className="group h-full bg-white hover:bg-[#FBF7EE] transition-colors p-8">
                <p className="font-display text-4xl font-bold text-outline leading-none group-hover:[-webkit-text-stroke-color:rgba(185,135,31,0.9)] transition-all">
                  {String(i + 1).padStart(2, "0")}
                </p>
                <h3 className="mt-5 font-display text-xl font-bold uppercase leading-tight text-stone-900">
                  {w.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-stone-600">{w.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
